import React, { useState } from 'react';
import { Button, Dialog, FormHelperText, Grid, Icon, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import Scrollbars from 'rc-scrollbars';
import DialogLoader from '../../../components/Loader/DialogLoader';
import { FileInput } from '../../../components/InputField/InputField';
import { DraggableComponent, Label, LinkS } from '../../../components/UiElements/UiElements';
import { withSnackbar } from '../../../components/Message/Alert';
import { PostDataAPI } from '../../../Services/APIService';
import { GetUserInfo } from '../../../Services/GetUserInfo';
import useStyles from '../addInventory/styles';

function BulkUpload({ dialogOpenClose, handleClose, handleSuccessClose, showMessage, ...props }) {
    const classes = useStyles();
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileError, setFileError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleFileChange = (file) => {
        setSelectedFile(file || null);
        if (!file) {
            setFileError('Please select a CSV file');
        } else if (!file.name.toLowerCase().endsWith('.csv')) {
            setFileError('Please select a valid CSV file');
        } else {
            setFileError('');
        }
    };

    const uploadInventory = () => {
        if (isLoading) {
            return;
        }
        if (!selectedFile) {
            setFileError('Please select a CSV file');
            return;
        }
        if (!selectedFile.name.toLowerCase().endsWith('.csv')) {
            setFileError('Please select a valid CSV file');
            return;
        }

        const userInfo = JSON.parse(GetUserInfo() || '{}');
        const formData = new FormData();
        formData.append('File', selectedFile);
        formData.append('EncUserID', userInfo && userInfo.user ? userInfo.user.userID : '');

        setIsLoading(true);
        PostDataAPI('deviceinventory/importInventory', formData, false, 'formData').then(result => {
            setIsLoading(false);
            if (result.success) {
                setSelectedFile(null);
                setFileError('');
                handleSuccessClose(result.message || 'Inventory imported successfully.');
            } else {
                showMessage('Error', result.message || 'Error importing inventory, please contact administrator', 'error', 3000);
            }
        }).catch(() => {
            setIsLoading(false);
            showMessage('Error', 'Error importing inventory, please contact administrator', 'error', 3000);
        });
    };

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            PaperComponent={DraggableComponent}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            maxWidth="md"
            {...props}
        >
            <div className={classes.dialogContent}>
                {isLoading ? <DialogLoader /> : ''}
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>Bulk Upload Inventory</Typography>
                        <Icon className={classes.closeIcon} onClick={isLoading ? undefined : handleClose} color="primary"><CloseIcon /></Icon>
                    </div>
                    <Scrollbars autoHeight autoHeightMax={570}>
                        <div className={classes.content}>
                            <Typography>
                                Download the sample CSV template and fill inventory records using the same column structure.
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <LinkS
                                        className={classes.changeBtn}
                                        style={{ alignItems: 'center', display: 'inline-flex', marginTop: '12px' }}
                                        href="/Documents/templates/DeviceInventory_SampleImport.csv"
                                        download="DeviceInventory_SampleImport.csv"
                                    >
                                        <GetAppIcon style={{ marginRight: '6px' }} /> Download Template
                                    </LinkS>
                                </Grid>
                                <Grid item xs={12}>
                                    <Label title="Upload CSV" size={12} mandatory={true} />
                                    <FileInput
                                        id="deviceInventoryFile"
                                        value={selectedFile ? selectedFile.name : ''}
                                        placeholder="Choose a CSV file"
                                        readOnly={true}
                                        IsDisabled={isLoading}
                                        handleChange={handleFileChange}
                                    />
                                    {fileError ? <FormHelperText className={classes.errorText}>{fileError}</FormHelperText> : ''}
                                </Grid>
                            </Grid>
                        </div>
                    </Scrollbars>
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} disabled={isLoading} onClick={handleClose}>Close</Button>
                            <Button className={classes.changeBtn} disabled={isLoading} onClick={uploadInventory}>Upload</Button>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}

export default withSnackbar(BulkUpload);
